// src/pages/NotFound.jsx
import { Link } from 'react-router-dom';

export default function NotFound({ user }) {
  return (
    <div style={{ textAlign: 'center', padding: '4rem' }}>
      <h1>🚫 404 - Page Not Found</h1>
      {user && (
        <p>Sorry, Commander <strong>{user.name}</strong>, that page doesn’t exist.</p>
      )}
      {!user && (
        <p>The page you’re looking for doesn’t exist.</p>
      )}
      <Link to={user ? "/dashboard" : "/"}>Go back {user ? "to dashboard" : "home"}</Link>
    </div>
  );
}
